import { Confirmation } from '@otp/ui';
import { Trans, useTranslation } from 'react-i18next';
import { Alert } from '@otp/icons';

type DeleteConfirmationProps = {
  objectTitle: string;
  objectType: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DeleteConfirmation = ({
  objectTitle,
  objectType,
  open,
  onClose,
  onConfirm,
}: DeleteConfirmationProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.form.delete-confirmation',
  });

  return (
    <Confirmation
      open={open}
      title={
        <div className="flex gap-1">
          <Alert /> {t('title')}
        </div>
      }
      message={
        <div>
          <Trans t={t} i18nKey="message" values={{ objectTitle, objectType }} />
        </div>
      }
      closeButtonText={t('close-button')}
      closeButtonColor="error"
      confirmButtonText={t('confirm-button')}
      confirmButtonColor="error"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
